module.exports = __webpack_public_path__ + "static/media/undraw_asesorias.d53d1e75.svg";